import http from '../http_v2'
let list = (params) => {
    return http.get('opservice/field/list', params)
}
export default {
    list
}
